import $ from 'jquery';
import Sms from 'portlets/site/order-sim/sms/sms';
import Delivery from 'portlets/site/order-sim/delivery/delivery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderSim',
			dom: {
				price: '.js-order-sim-price'
			},
			classes: {}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		this.$price = this.$el.find(this.options.dom.price);
		return this;
	}

	onPriceChange(price) {
		this.$price.html(price);
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.sms = new Sms().render();
			self.delivery = new Delivery({
				update: self.onPriceChange.bind(self)
			}).render();
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order-sim/order-sim.js